import React from "react";
import {Helmet} from "react-helmet";

class PageTitle extends React.Component {

  	render() {
		return (
			<div className="Page_Title">
	            <Helmet>
			        <title>Introducing Smart eCommerce sites | Digipanda</title>
			        <meta name="description" content="the future of selling online" />
			    </Helmet>
			</div>
		);
	}
};

export default PageTitle;
